import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";
import CountUp from "react-countup";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { Image } from "antd";
import { all_routes } from "../router/all_routes";
// import { Listinggriddata } from '../../core/data/json/listinggrid_data';
// import { CarInfo } from '../../core/data/interface/interface';
import { useDispatch } from "react-redux";
// import { setReservationDetails } from "../../core/data/redux/action";
import { ToastContainer, toast } from 'react-toastify';
import { CarService } from "../../api/services/car.service";
import { Car } from "../../api/types";
import { UUID } from "crypto";
// Fix the import path - make sure it's correctly pointing to your CarCard component
import CarCard from "../common/CarCard";

const Home = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const routes = all_routes;
  const [carData, setCarData] = useState<Car[]>([]);

  const scrollToRecommended = () => {
    const element = document.getElementById('recommended-cars');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  useEffect(() => {
    AOS.init({ duration: 1200, once: true });

    const fetchCarData = async () => {
      try {
        const latestCars = await CarService.getLatest();

        if (latestCars) {
          setCarData(latestCars);
        }
      } catch (error) {
        console.error("Failed to fetch car data", error);
      }
    };

    fetchCarData();
  }, []);

  return (
    <>
    <ToastContainer />
      {/* Hero Section */}
      <section className="hero-section-modern">
        <div className="hero-background-overlay"></div>
        <div className="hero-animated-bg">
          <div className="floating-element floating-element-1"></div>
          <div className="floating-element floating-element-2"></div>
          <div className="floating-element floating-element-3"></div>
        </div>

        <div className="container">
          <div className="hero-content-wrapper">
            <div className="row align-items-center justify-content-center">
              <div className="col-lg-10 col-xl-8">
                <div className="hero-text-center">
                  <div className="hero-badge" data-aos="fade-down" data-aos-delay="100">
                    <i className="fa-solid fa-award"></i>
                    <span>Showroom Premium</span>
                  </div>

                  <h1 className="hero-title" data-aos="fade-up" data-aos-delay="200">
                    Descoperă-ți<br />
                    <span className="hero-title-highlight">Mașina Perfectă</span>
                  </h1>

                  <p className="hero-description" data-aos="fade-up" data-aos-delay="300">
                    Selecție exclusivistă de automobile premium, verificate tehnic și estetic.
                    <br />Transparență totală, expertiză profesională, pasiune pentru mașini de calitate.
                  </p>

                  <div className="hero-actions" data-aos="fade-up" data-aos-delay="400">
                    <Link
                      to={routes.listinggrid}
                      className="btn-hero btn-hero-primary"
                    >
                      <span>Explorează Stocul</span>
                      <i className="feather icon-arrow-right"></i>
                    </Link>
                    <a
                      href="tel:+40123456789"
                      className="btn-hero btn-hero-secondary"
                    >
                      <i className="feather icon-phone"></i>
                      <span>Contactează-ne</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="scroll-indicator" onClick={scrollToRecommended} data-aos="fade-up" data-aos-delay="800">
          <div className="scroll-animation">
            <div className="scroll-mouse">
              <div className="scroll-wheel"></div>
            </div>
          </div>
          <div className="scroll-arrow">
            <i className="feather icon-chevron-down"></i>
          </div>
        </div>

        {/* Decorative Elements */}
        <div className="hero-decoration hero-decoration-1"></div>
        <div className="hero-decoration hero-decoration-2"></div>
      </section>
      {/* /Hero Section */}

            {/* Featured Cars */}
      <section id="recommended-cars" className="section-modern recommended-cars-modern">
        <div className="container">
          <div className="section-heading-modern" data-aos="fade-up">
            <div className="section-badge">
              <i className="fa-solid fa-star"></i>
              <span>Selecție Premium</span>
            </div>
            <h2>Mașini Recomandate</h2>
            <p>
              Descoperă cele mai recente adăugiri în colecția noastră exclusivistă
            </p>
          </div>

          <div className="cars-showcase-modern">
            {carData.length === 0 ? (
              <div className="empty-state-modern" data-aos="fade-up">
                <i className="fa-solid fa-car"></i>
                <h3>În curând</h3>
                <p>Stocul nostru se actualizează constant. Revino în curând!</p>
              </div>
            ) : (
              <div className="row g-4">
                {carData.slice(0, 3).map((car, index) => (
                  <div
                    key={car.id}
                    className="col-xl-4 col-lg-4 col-md-6 col-12"
                    data-aos="fade-up"
                    data-aos-delay={index * 100}
                  >
                    <CarCard
                      car={car}
                      selectedItems={[]}
                      onHeartClick={() => {}}
                    />
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="section-cta-modern" data-aos="fade-up" data-aos-delay="400">
            <Link
              to={routes.listinggrid}
              className="btn-modern btn-modern-primary"
            >
              <span>Vezi Toată Colecția</span>
              <i className="feather icon-arrow-right" />
            </Link>
          </div>
        </div>
      </section>

      {/* Services Steps */}
      <section className="section-modern services-modern">
        <div className="container">
          <div className="section-heading-modern" data-aos="fade-up">
            <div className="section-badge">
              <i className="fa-solid fa-route"></i>
              <span>Proces Simplificat</span>
            </div>
            <h2>Cum funcționează</h2>
            <p>
              Trei pași simpli și transparenți către mașina ta perfectă
            </p>
          </div>

          <div className="services-grid-modern">
            <div className="row">
              <div className="col-lg-4 col-md-6 col-12" data-aos="fade-up" data-aos-delay="100">
                <div className="service-card-modern">
                  <div className="service-number">01</div>
                  <div className="service-icon-modern">
                    <i className="fa-solid fa-search"></i>
                  </div>
                  <h3>Răsfoiește Colecția</h3>
                  <p>
                    Explorează showroom-ul nostru online sau fizic. Fiecare mașină este verificată tehnic și estetic.
                  </p>
                  <div className="service-decoration"></div>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 col-12" data-aos="fade-up" data-aos-delay="200">
                <div className="service-card-modern service-card-highlighted">
                  <div className="service-number">02</div>
                  <div className="service-icon-modern">
                    <i className="fa-solid fa-calendar-check"></i>
                  </div>
                  <h3>Programează Vizionare</h3>
                  <p>
                    Contactează-ne pentru o întâlnire personalizată. Consultanții noștri îți oferă toate detaliile.
                  </p>
                  <div className="service-decoration"></div>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 col-12" data-aos="fade-up" data-aos-delay="300">
                <div className="service-card-modern">
                  <div className="service-number">03</div>
                  <div className="service-icon-modern">
                    <i className="fa-solid fa-key"></i>
                  </div>
                  <h3>Pleacă la Drum</h3>
                  <p>
                    Finalizăm documentația rapid și transparent. Ești gata să conduci mașina visurilor tale!
                  </p>
                  <div className="service-decoration"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="services-bg-decoration"></div>
      </section>



    </>
  );
};

export default Home;
